export function getdata() {
	var obj = {

			headDataI:[
				{
					title:"操作",
					prop:"cz",
					width:"150px",
					custom:true,
					fixed:'left',
				},
				{
					title:'*序号',
					prop:'cbj_0_x_1',
					width: "100px",
					custom: true,
					fixed:'left',

				},
				{
					title: "*费款所属",
					children:[
						{
							title: " 期起",
							custom: true,
							prop: "cbj_0_x_2",
							width: "200px",
						},
					],
				}, {
					title: "*费款所属",
					children:[
						{
							title: " 期止",
							custom: true,
							prop: "cbj_0_x_3",
							width: "200px",
						},
					],
				},{
					title: "*上年在职职工工资总额",
					custom: true,
					prop: "cbj_0_x_4",
					width: "200px",
				},{
					title: "*上年在职",
					children:[
						{
							title: " 职工人数",
							custom: true,
							prop: "cbj_0_x_5",
							width: "200px",
						},
					],
				},{
					title: "*应安排残疾人就业比例",
					custom: true,
					prop: "cbj_0_x_6",
					width: "200px",
				},{
					title: "*上年实际安排残疾人就业人数",
					custom: true,
					prop: "cbj_0_x_7",
					width: "200px",
				},{
					title: "*上年在职职工年平均工资",
					custom: true,
					prop: "cbj_0_x_8",
					width: "200px",
				},{
					title: "*本期应纳",
					children:[
						{
							title: " 费额",
							custom: true,
							prop: "cbj_0_x_9",
							width: "200px",
						},
					],
				},{
					title: "减免类型",
					custom: true,
					prop: "cbj_0_x_10",
					width: "200px"
				},{
					title: "本期减免",
					children:[
						{
							title: " 费额",
							custom: true,
							prop: "cbj_0_x_11",
							width: "200px",
						},
					],
				},{
					title: "本期已缴",
					children:[
						{
							title: " 费额",
							custom: true,
							prop: "cbj_0_x_12",
							width: "200px",
						},
					]
				},{
					title: "本期应补（退）费额",
					custom: true,
					prop: "cbj_0_x_13",
					width: "200px"
				}
			],
			tableDataII:{
				cbj_fdfzrqm:{
					disablecbj_fdfzrqm:false,
					cbj_fdfzrqm:{
						cellCode:"cbj_fdfzrqm",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				cbj_jfrgsmc:{
					disablecbj_jfrgsmc:false,
					cbj_jfrgsmc:{
						cellCode:"cbj_jfrgsmc",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				cbj_jfrtbrq:'',
				cbj_dwjbr:{
					disablecbj_dwjbr:false,
					cbj_dwjbr:{
						cellCode:"cbj_dwjbr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				cbj_slswjg:{
					disablecbj_slswjg:false,
					cbj_slswjg:{
						cellCode:"cbj_slswjg",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				cbj_slr:{
					disablecbj_slr:false,
					cbj_slr:{
						cellCode:"cbj_slr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				cbj_sbrq:'',
				cbj_slrq:'',
			},
			tableDataI:[
				{
						title:'流动负债：',
						disabledcbj_0_x_1:false,
						disabledcbj_0_x_2:false,
						disabledcbj_0_x_3:false,
						disabledcbj_0_x_4:false,
						disabledcbj_0_x_5:false,
						disabledcbj_0_x_6:false,
						disabledcbj_0_x_7:false,
						disabledcbj_0_x_8:false,
						disabledcbj_0_x_9:false,
						disabledcbj_0_x_10:false,
						disabledcbj_0_x_11:false,
						disabledcbj_0_x_12:false,
						disabledcbj_0_x_13:false,
						cbj_0_x_1: {
							cellCode:"cbj_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_2: {
							cellCode:"cbj_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_3: {
							cellCode:"cbj_0_x_3",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_4: {
							cellCode:"cbj_0_x_4",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_5: {
							cellCode:"cbj_0_x_5",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_6: {
							cellCode:"cbj_0_x_6",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_7: {
							cellCode:"cbj_0_x_7",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_8: {
							cellCode:"cbj_0_x_8",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_9: {
							cellCode:"cbj_0_x_9",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_10: {
							cellCode:"cbj_0_x_10",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_11: {
							cellCode:"cbj_0_x_11",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_12: {
							cellCode:"cbj_0_x_12",
							cellType:"1",
							cellVal:"240040043.08"
						},

						cbj_0_x_13: {
							cellCode:"cbj_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},
					{
						title:'流动负债：',
						disabledcbj_0_x_1:false,
						disabledcbj_0_x_2:false,
						disabledcbj_0_x_3:false,
						disabledcbj_0_x_4:false,
						disabledcbj_0_x_5:false,
						disabledcbj_0_x_6:false,
						disabledcbj_0_x_7:false,
						disabledcbj_0_x_8:false,
						disabledcbj_0_x_9:false,
						disabledcbj_0_x_10:false,
						disabledcbj_0_x_11:false,
						disabledcbj_0_x_12:false,
						disabledcbj_0_x_13:false,
						cbj_0_x_1: {
							cellCode:"cbj_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_2: {
							cellCode:"cbj_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_3: {
							cellCode:"cbj_0_x_3",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_4: {
							cellCode:"cbj_0_x_4",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_5: {
							cellCode:"cbj_0_x_5",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_6: {
							cellCode:"cbj_0_x_6",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_7: {
							cellCode:"cbj_0_x_7",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_8: {
							cellCode:"cbj_0_x_8",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_9: {
							cellCode:"cbj_0_x_9",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_10: {
							cellCode:"cbj_0_x_10",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_11: {
							cellCode:"cbj_0_x_11",
							cellType:"1",
							cellVal:"240040043.08"
						},
						cbj_0_x_12: {
							cellCode:"cbj_0_x_12",
							cellType:"1",
							cellVal:"240040043.08"
						},

						cbj_0_x_13: {
							cellCode:"cbj_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
					}
			],

	}
	return obj
}
